import { TmBaseError } from '@/core/error/tmBaseError'

export class TmInvalidEnumValueError extends TmBaseError {
  public readonly name = 'TmInvalidEnumValueError'

  constructor(value: string | number, enumObj: Record<string, string | number>) {
    super(`Value "${value}" is not a valid enum value. Enum = "${JSON.stringify(enumObj)}"`, {
      value,
      enumObj,
    })
  }
}
